import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { Asset, Equipment, CreateAsset } from '../../context-discovery-services/models';

@Component({
  selector: 'adminapp-create-new-asset',
  templateUrl: './create-new-asset.component.html',
  styleUrls: ['./create-new-asset.component.scss']
})
export class CreateNewAssetComponent implements AfterViewInit {

  selectedEquipment: string;
  @ViewChild('createNewAssetDialog') createNewAssetDialog: any;
  @ViewChild('assetNameInput') assetNameInput: any;
  @ViewChild('equipmentSelectorForNewAsset') equipmentSelectorForNewAsset: any;

  @Input()
  assetsList: Array<Asset>;

  @Input()
  equipmentList: Array<Equipment>;

  @Output()
  assetCreated: EventEmitter<CreateAsset> = new EventEmitter<CreateAsset>();

  constructor() { }

  ngAfterViewInit(): void {
    this.assetNameInput.nativeElement.addEventListener('value-changed', this.assetNameChanged.bind(this));
  }

  open(equipmentInContext: string) {
    this.selectedEquipment = equipmentInContext;
    this.createNewAssetDialog.nativeElement.open();
    this.assetNameInput.nativeElement.value = '';
  }

  onAssetCreated() {
    this.assetCreated.emit(new CreateAsset(this.equipmentSelectorForNewAsset.getSelectedValue(),
      this.assetNameInput.nativeElement.value));
  }

  assetNameChanged(event) {
    if (/\s/g.test(event.detail.value)) {
      this.assetNameInput.nativeElement.setAttribute('error-message',
        'Please enter a correct asset name. No spaces allowed.');

      this.setAttributesOfInputNativeElement(true);
      return;
    } else if (event.detail.value.length < 3 || event.detail.value.length > 25) {
      this.assetNameInput.nativeElement.setAttribute('error-message',
        'Asset name should contain at least 3 characters and not more than 25 characters.');

      this.setAttributesOfInputNativeElement(true);
      return;
    } else {
      if (this.assetsList && this.assetsList.some(asset => asset.label === event.detail.value)) {
        this.assetNameInput.nativeElement.setAttribute('error-message',
          'An asset having this name already exists. Please type a new name.');

        this.setAttributesOfInputNativeElement(true);
        return;
      }
    }

    this.setAttributesOfInputNativeElement(false);
  }

  private setAttributesOfInputNativeElement(setForInvalid: boolean) {
    if (setForInvalid) {
      this.assetNameInput.nativeElement.setAttribute('invalid', '');
    } else {
      this.assetNameInput.nativeElement.removeAttribute('error-message');
      this.assetNameInput.nativeElement.removeAttribute('invalid');
    }
  }
}
